import type * as hast from 'hast';

/**
 * Normalize attributes of a custom element.
 */
export function getCustomAttributes(node: hast.Element): { [key: string]: string } {
    const { dataTag, dataGbCustomBlock, dataGbCustomInline, dataGitbookProps, ...data } =
        node.properties || {};

    // Extract the keys and values that have been encoded in order and re set the properties
    // without losing the keys case.
    if (dataGitbookProps) {
        const parsedData = JSON.parse(dataGitbookProps as string) as object;
        Object.keys(parsedData).forEach((key) => {
            data[key] = parsedData[key];
        });
    }

    // Properties on the Block are in the format dataPropName, so normalize these
    // values.
    const normalizedData = Object.keys(data).reduce((result, key) => {
        if (key.indexOf('data') === 0) {
            const dataKey = key.substring('data'.length);
            const normalizedKey = dataKey[0].toLowerCase() + dataKey.substring(1);

            result[normalizedKey] = data[key];
        } else {
            result[key] = data[key];
        }
        return result;
    }, {});

    return normalizedData;
}

/**
 * Return true if the given element is a custom node.
 */
export function isElementCustomNode(element: hast.Element): boolean {
    return (
        ((element.tagName === 'div' && typeof element.properties?.dataGbCustomBlock === 'string') ||
            (element.tagName === 'span' &&
                typeof element.properties?.dataGbCustomInline === 'string')) &&
        typeof element.properties?.dataTag === 'string'
    );
}

/**
 * Return true if the given element is a custom node.
 */
export function isElementCustomNodeWithTag(element: hast.Element, tag: string): boolean {
    return isElementCustomNode(element) && element.properties?.dataTag === tag;
}
